import { create } from "zustand";
import { getAllGateways } from "../services";
import { Gateway } from "../types/payment_gateway";

interface GatewayState {
  gateways: Gateway[];
  loading: boolean;
  error: string | null;
  fetchGateways: () => Promise<void>;
  addGateway: (gateway: Gateway) => void;
}

export const useGatewayStore = create<GatewayState>((set) => ({
  gateways: [],
  loading: false,
  error: null,

  fetchGateways: async () => {
    set({ loading: true, error: null });
    try {
      const data = await getAllGateways();
      set({ gateways: data, loading: false });
    } catch (err: any) {
      set({ error: err.message || "Failed to fetch gateways", loading: false });
    }
  },

  addGateway: (gateway) =>
    set((state) => ({
      gateways: [...state.gateways, gateway],
    })),
}));
